import RoutePaths from '@routePaths';
import { CustomerUserManagementPermission } from '@shared/enums/CustomerUserManagementPermission';

export interface CustomerRouteAuthorization {
  anyOf: CustomerUserManagementPermission[];
}

const manageUsersPermissions = [
  CustomerUserManagementPermission.AddUser,
  CustomerUserManagementPermission.EditUser,
  CustomerUserManagementPermission.DeleteUser,
  CustomerUserManagementPermission.ManageRoles,
];

export const getCustomerRouteAuthorization = (pathname: string): CustomerRouteAuthorization | undefined => {
  if (pathname === RoutePaths.ManageUsers) return { anyOf: manageUsersPermissions };
  if (pathname === RoutePaths.AddUser) return { anyOf: [CustomerUserManagementPermission.AddUser] };
  if (/^\/users\/[^/]+\/edit$/.test(pathname)) return { anyOf: [CustomerUserManagementPermission.EditUser] };
  return undefined;
};

export const hasCustomerRouteAccess = (pathname: string, permissionIds: Set<string>) => {
  const authorization = getCustomerRouteAuthorization(pathname);
  return !authorization || authorization.anyOf.some((permission) => permissionIds.has(permission));
};
